<template>
    <div class="relative w-full">
        <button
            type="button"
            class="w-full text-left text-new-900 placeholder:text-new-400 focus:outline-none focus:ring-0"
            :class="btnClass"
            @click.stop="open = !open"
        >
            {{ label }}
        </button>

        <transition name="fade">
            <div
                v-if="open"
                class="absolute z-[60] mt-2 w-[280px] rounded-xl border border-gray-200 bg-white shadow-lg p-3 right-0"
                @click.stop
            >
                <div class="flex items-center justify-between py-2">
                    <div class="text-sm">
                        <p class="font-medium text-gray-800">Guests</p>
                        <p class="text-gray-500">Ages 13+</p>
                    </div>
                    <div class="flex items-center gap-2">
                        <button
                            class="grid border rounded-md place-items-center size-7"
                            @click="dec('guests')"
                        >
                            −
                        </button>
                        <span class="w-6 text-center">{{ local.guests }}</span>
                        <button
                            class="grid border rounded-md place-items-center size-7"
                            @click="inc('guests')"
                        >
                            +
                        </button>
                    </div>
                </div>

                <!-- Tambahan lain (children/infants/pets) kalau diperlukan -->
                <!--
        <div class="flex items-center justify-between py-2">
          <div class="text-sm">
            <p class="font-medium text-gray-800">Children</p>
            <p class="text-gray-500">Ages 2–12</p>
          </div>
          <div class="flex items-center gap-2">
            <button class="grid border rounded-md place-items-center size-7" @click="dec('children')">−</button>
            <span class="w-6 text-center">{{ local.children }}</span>
            <button class="grid border rounded-md place-items-center size-7" @click="inc('children')">+</button>
          </div>
        </div>
        -->

                <div class="flex justify-end gap-2 pt-2">
                    <button
                        class="px-3 py-1 text-sm border rounded-md"
                        @click="cancel"
                    >
                        Cancel
                    </button>
                    <button
                        class="px-3 py-1 text-sm text-white rounded-md bg-secondary"
                        @click="apply"
                    >
                        Apply
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "BaseGuestsPill",
    props: {
        modelValue: {
            type: Object,
            default: () => ({ guests: 1 }),
        },
        placeholder: { type: String, default: "Who" },
        size: { type: String, default: "md" }, // sm|md|lg -> sinkron dg BasePillField
    },
    data() {
        return {
            open: false,
            local: { guests: 1, children: 0, infants: 0, pets: 0 },
        };
    },
    computed: {
        label() {
            const g = this.modelValue?.guests ?? 1;
            return g > 0 ? `${g} Guest${g > 1 ? "s" : ""}` : this.placeholder;
        },
        btnClass() {
            switch (this.size) {
                case "sm":
                    return "h-10 text-sm";
                case "lg":
                    return "h-12 text-sm";
                default:
                    return "h-11 text-sm";
            }
        },
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(v) {
                this.local = {
                    ...{ guests: 1, children: 0, infants: 0, pets: 0 },
                    ...v,
                };
            },
        },
    },
    mounted() {
        document.addEventListener("click", this.onClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.onClickOutside);
    },
    methods: {
        onClickOutside(e) {
            if (this.open && !this.$el.contains(e.target)) this.open = false;
        },
        inc(key) {
            this.local[key] = Math.min(99, (this.local[key] ?? 0) + 1);
        },
        dec(key) {
            this.local[key] = Math.max(0, (this.local[key] ?? 0) - 1);
        },
        cancel() {
            this.open = false;
            this.local = { ...this.modelValue };
        },
        apply() {
            this.$emit("update:modelValue", { ...this.local });
            this.open = false;
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.12s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
